import React from 'react'
import EzCancelPlus from 'SVGPath/EzcancelPlusIcon'
import { isEmpty } from 'AccountsUtils'
import { path } from 'AccountsUtils/common'

const EzcancelPlusBanner = ({ bannerData = {} }) => {
  const bannerInfoObj = {
    AVAILED: {
      bannerColor: '#EBF9F6',
      iconWidth: '24px'
    },
    AVAILED_CANCELLED: {
      bannerColor: '#FBECEC',
      iconWidth: '12px'
    }
  }
  let bannerObj = (bannerData && bannerInfoObj[bannerData.status]) || {}
  if (isEmpty(bannerObj)) {
    bannerObj = {
      bannerColor: '#FCF7F0',
      iconWidth: '40px'
    }
  }
  bannerObj.vasType = bannerData.vas_type
  const domain = path(['location', 'hostname'], window)
  return (
    <div className="flex flex-middle flex-start px-4 py-4 br-4" style={{ backgroundColor: bannerObj.bannerColor }}>
      <div className="flex-no-shrink">
        <If condition={bannerObj.vasType === 'FLEXIFLY'}>
          <img
            width="24px"
            height="24px"
            alt="insurance"
            src="https://qaui.cltp.co/images/logos/amend_insurance.png"
          />
        </If>
        <If condition={bannerObj.vasType === 'EZCANCEL_PLUS'}>
          <EzCancelPlus width={bannerObj.iconWidth} height={bannerObj.iconWidth} />
        </If>
      </div>
      <p className="fs-3 ml-1 ff-inter">
        {bannerData.message && bannerData.message.toString()}
        {' '}
        <span
          onClick={() => {
            window.open(`https://${domain}/${bannerData.url}`)
          }}
          className="c-pointer c-secondary-500 ff-inter"
        >
          {bannerData.url_text}
        </span>
      </p>
    </div>
  )
}

export default EzcancelPlusBanner
